module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/base64-303.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/tools/base64.md
// module id = 767
// module chunks = 468